import { useQuery } from '@tanstack/react-query'

import { fetchCourts } from '@/lib/venue/courtApi'
import type { CourtListView } from '@/lib/venue/courtTypes'

/** 목록·쓰기 3EP 가 공유하는 쿼리 키 — 단건 조회 EP 가 없어 이 캐시가 유일한 원천이다(#597 §1). */
export function courtsQueryKey(venueId: string) {
  return ['venue', venueId, 'courts'] as const
}

export function useCourts(venueId: string) {
  return useQuery<CourtListView>({
    queryKey: courtsQueryKey(venueId),
    queryFn: () => fetchCourts(venueId),
  })
}
